export const imageUrl = {
    url:'https://kpmtextile.com/service/uploads'
    // url:'http://localhost:81/uploads'
}